import { PaletteOptions, createTheme } from "@mui/material";



import { colors } from "./colors";
import { constant } from "lodash";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.light.primary_midnight, // primary-midnight
      light: colors.light.text_primary, // text-primary
      dark: colors.light.locked_primary, // locked-primary
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    secondary: {
      main: colors.light.secondary_guardian, // --chat-bot-theme-secondary-guardian
      light: colors.light.input_guardian_light, // input-guardian-light
      dark: colors.light.button_tonal_guardian, // button-tonal-guardian
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    tertiary: {
      main: colors.light.tertiary_nautical, // --chat-bot-theme-tertiary-nautical
    },
    error: {
      main: colors.light.error_text, // --chat-bot-theme-error-text
      light: colors.light.error_container, // --chat-bot-theme-error-container
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    warning: {
      main: colors.light.warning_text, // --chat-bot-theme-warning-text
      light: colors.light.warning_container, // --chat-bot-theme-warning-container
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    info: {
      main: colors.light.info_text, // --chat-bot-theme-info-text
      light: colors.light.info_container, // --chat-bot-theme-info-container
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    success: {
      main: colors.light.success_text, // --chat-bot-theme-success-text
      light: colors.light.success_container, // --chat-bot-theme-success-container
      contrastText: colors.light.text_primary_light, // text-primary-light
    },
    text: {
      primary: colors.light.text_primary, // --chat-bot-theme-text-primary
      secondary: colors.light.text_secondary, // --chat-bot-theme-text-secondary
      disabled: colors.light.text_muted, // --chat-bot-theme-text-muted
    },
    background: {
      default: colors.light.bgoffwhitecool, // --chat-bot-theme-bgoffwhitecool
      paper: colors.light.bgoffwhiteneutral, // --chat-bot-theme-bgoffwhiteneutral
    },
    divider: colors.light.divider_line_pale_gray, // --chat-bot-theme-divider-line-pale-gray

    // Custom colors
    accent: {
      main: colors.light.accent_horizon, // accent-horizon
      light: colors.light.coolactive, // coolactive
    },
    slate: {
      main: colors.light.slate_main, // slate
      light: colors.light.slate_light, // text-primary-slate
    },
    grey: {
      50: colors.light.bgoffwhitewarm, // --chat-bot-theme-bgoffwhitewarm
      100: colors.light.bgoffwhitebluetint, // --chat-bot-theme-bgoffwhitebluetint
      200: colors.light.divider_line_soft_white, // --chat-bot-theme-divider-line-soft-white
      300: colors.light.divider_line_pale_gray, // --chat-bot-theme-divider-line-pale-gray
      400: colors.light.divider_line_light_gray, // --chat-bot-theme-divider-line-light-gray
      500: colors.light.light_grey, // --chat-bot-theme-light-grey
      600: colors.light.light_charcoal, // --chat-bot-theme-light-charcoal
      700: colors.light.soft_grey, // --chat-bot-theme-soft-grey
      800: colors.light.charcoal, // --chat-bot-theme-charcoal
      900: colors.light.jet_black, // --chat-bot-theme-jet-black
    },
    action: {
      active: colors.light.coolactive, // --chat-bot-theme-coolactive
      hover: colors.light.coolactive_hover,
      selected: colors.light.selected, // --chat-bot-theme-selected
      disabled: colors.light.disabled, // --chat-bot-theme-disabled
      disabledBackground: colors.light.disabledBackground, // --chat-bot-theme-disabledBackground
    },
    // Custom colors not part of MUI standard palette
    custom: {
      // Brand colors
      brandPrimary: colors.light.brand_primary,           // #e50c20 - Main brand red
      brandPrimaryDark: colors.light.brand_primary_dark,  // #b8091a - Darker red for hover
      brandPrimaryLight: colors.light.brand_primary_light, // #ff4757 - Lighter red
      brandPrimarySubtle: colors.light.brand_primary_subtle, // #ffe5e7 - Very light red
      
      // Additional backgrounds
      backgroundPrimary: colors.light.background_primary,
      backgroundSecondary: colors.light.background_secondary,
      backgroundTertiary: colors.light.background_tertiary,
      
      // Text colors
      textOnRed: colors.light.text_on_red,
      
      // Slate colors
      slateMain: colors.light.slate_main,
      slateLight: colors.light.slate_light,
      slateDark: colors.light.slate_dark,
      
      // Legacy support
      accent: {
        horizon: colors.light.accent_horizon,
      },
      heroBlue: colors.light.hero_blue,
      placeholderGray: colors.light.placeholder_gray,
      glacial: colors.light.natural_light_BG_glacial,
      buttonTonalGuardian: colors.light.button_tonal_guardian,
      inputGuardianLight: colors.light.input_guardian_light,
      lockedPrimary: colors.light.custom_locked_primary,
      constantBlack: colors.light.constant_black,
    },
  } as PaletteOptions,
  typography: {
    fontFamily: "'Poppins', Helvetica",
    h1: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "48px",
      fontWeight: 700,
      lineHeight: "56px",
      letterSpacing: "0px",
    },
    h2: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "36px",
      fontWeight: 700,
      lineHeight: "44px",
      letterSpacing: "0px",
    },
    h3: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "28px",
      fontWeight: 500,
      lineHeight: "36px",
      letterSpacing: "0px",
    },
    h4: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "32px",
      letterSpacing: "0px",
    },
    h5: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: "26px",
      letterSpacing: "0px",
    },
    body1: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0px",
    },
    body2: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      letterSpacing: "0px",
    },
    caption: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: "0px",
    },
    button: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.014000000208616257px",
      textTransform: "none",
    },
    subtitle1: {
      fontFamily: "'Poppins', Helvetica",
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "0.01600000023841858px",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "rgba(239, 242, 245, 1)", // --chat-bot-theme-bgoffwhitecool
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
        },
        containedPrimary: {
          background:
            "linear-gradient(90deg, rgba(134,97,252,1) 0%, rgba(7,221,216,1) 100%)",
          color: "rgba(244, 255, 255, 1)", // --chat-bot-theme-natural-light-BG-glacial
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "16px",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(247, 249, 251, 1)", // --chat-bot-theme-card-background
          borderRadius: "8px",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(240, 242, 247, 1)", // --chat-bot-theme-divider-line-pale-gray
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          ...theme.typography.body2,
        }),
        head: ({ theme }) => ({
          ...theme.typography.subtitle1,
          fontWeight: 500,
        }),
        body: ({ theme }) => ({
          ...theme.typography.body1,
        }),
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: ({ theme }) => ({
          ...theme.typography.h5,
        }),
        secondary: ({ theme }) => ({
          ...theme.typography.body2,
          color: theme.palette.text.secondary,
        }),
      },
    },
  },
});
